<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa fa-building fa-fw"
                            :edicao="!$store.state.user.id_unidade_operacao"
                            type="select"
                            placeholder="Todas"
                            :optionsList="$util.unidades_com_tags(true, true)"
                            optionsData="id_unidade_operacao"
                            v-model="filtro.id_unidade_operacao">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa fa-filter fa-fw"
                            type="select"
                            placeholder="Todas"
                            :optionsList="[
                                { id: 'X', search: 'Conta Caixa' },
                                { id: 'C', search: 'Conta Corrente' },
                                { id: 'A', search: 'Conta de Aplicação' },
                                { id: 'E', search: 'Conta de Empréstimos' },
                                { id: 'G', search: 'Conta Garantida' },
                                { id: 'T', search: 'Conta Transitória' },
                            ]"
                            optionsData="id"
                            v-model="filtro.st_tipo" />
                    </div>
                </div>
                <div class="form-row mt-2">
                    <div class="col col-12 col-md-6">
                        <az-input
                            icon="fas fa-search fa-fw"
                            placeholder="Pesquisar..."
                            v-model="filtro.search">
                            <template v-slot:buttonposb>
                                <print-export printid="impressao" />
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa-solid fa-money-bill-transfer fa-fw"
                            type="select"
                            placeholder="Todas"
                            :optionsList="[
                                { id: 'S', search: 'Fluxo de Caixa' },
                                { id: 'N', search: 'Não Fluxo de Caixa' },
                            ]"
                            optionsData="id"
                            v-model="filtro.fluxo" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            placeholder="Todas as Contas..."
                            icon="fas fa-money-check-alt"
                            type="select"
                            optionsMode="aql"
                            service="contas.index"
                            optionsName="contas.index.classe"
                            optionsData="id_conta"
                            optionsDisplay="search"
                            :optionsParm="{ ativas: true, classificacao: true }"
                            v-model="filtro.id_conta" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-6">
                        <az-input
                            type="button-group"
                            :optionsList="[
                                { id: 'G', search: 'Geral' },
                                { id: 'U', search: 'Por Unidade' },
                                { id: 'T', search: 'Por Tipo' },
                            ]"
                            v-model="filtro.tipo_quebra" />
                    </div>

                    <div class="col col-12 col-md-6">
                        <az-input
                            type="button-group"
                            :optionsList="[
                                { id: 'F', search: 'Real' },
                                { id: 'C', search: 'Conciliado' },
                                { id: 'A', search: 'Ambos' },
                            ]"
                            v-model="filtro.tipo_saldo" />
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && dados && dados.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state v-if="!lista.length" :loading="true" :msg="dados === null ? 'Buscar Contas' : 'Nenhuma Conta Identificada.'" />

        <template v-else>

            <div class="alert alert-secondary d-flex justify-content-between">
                <div>Período: {{ $util.getFormatDate(dados.parms.inicio) }} a {{ $util.getFormatDate(dados.parms.fim) }}</div>
                <div v-if="dados.unidade">{{ dados.unidade }}</div>
            </div>

            <div class="mb-1">
                <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in classes" :key="icx">
                    <span class="badge badge-success mr-1">
                        {{ classe }}
                    </span>
                </a>
            </div>

            <div id="impressao">

                <cabecalho-generico titulo="Contas" v-if="dados && dados.parms">
                    <div>
                        <div>Período: {{ $util.getFormatDate(dados.parms.inicio) }} a {{ $util.getFormatDate(dados.parms.fim) }}</div>
                        <div v-if="dados.unidade">{{ dados.unidade }}</div>
                        <div v-if="dados.parms.search">Pesquisa: {{ dados.parms.search }}</div>
                    </div>
                </cabecalho-generico>

                <table class="table table-sm table-hover bg-white cabecalho-fixo">
                    <thead>
                        <tr>
                            <th>Conta</th>
                            <th class="text-right">Saldo Inicial</th>
                            <th class="text-right">Entradas</th>
                            <th class="text-right">Saídas</th>
                            <th class="text-right">Saldo Final</th>
                            <template v-if="tem_cheque_especial">
                                <th class="text-right">Cheque Especial</th>
                                <th class="text-right">Saldo Total</th>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(items, grupo, igx) in lista_agrupada">
                            <!-- Agrupamento -->
                            <tr :key="'G' + igx" class="table-primary" v-show="grupo != '-'">
                                <th>
                                    {{ grupo }}
                                </th>
                                <th class="text-right">
                                    <div v-if="filtro.tipo_saldo != 'C'" :class="total('saldo_r', items) >= 0 ? 'text-primary' : 'text-danger' ">
                                        {{ $util.formatMoeda(total('saldo_r', items)) }}
                                    </div>
                                    <div v-if="filtro.tipo_saldo != 'F'" :class="( total('saldo_c', items) >= 0 ? 'text-primary ' : 'text-danger '  ) + ( total('saldo_c') >= 0 ? 'text-primary ' : 'text-danger ' ) + ( filtro.tipo_saldo == 'A' ? 'small text-muted' : '' ) ">
                                        <span v-if="filtro.tipo_saldo == 'A'">
                                            <i class="fa-solid fa-copyright mr-1"></i>
                                        </span>
                                        {{ $util.formatMoeda(total('saldo_c', items)) }}
                                    </div>
                                </th>
                                <th class="text-right">
                                    {{ $util.formatMoeda(total('entradas', items)) }}
                                </th>
                                <th class="text-right">
                                    {{ $util.formatMoeda(total('saidas', items)) }}
                                </th>
                                <th class="text-right">
                                    <div v-if="filtro.tipo_saldo != 'C'" :class="total('saldo_final.saldo_r', items) >= 0 ? 'text-primary' : 'text-danger' ">
                                        {{ $util.formatMoeda(total('saldo_final.saldo_r', items)) }}
                                    </div>
                                    <div v-if="filtro.tipo_saldo != 'F'" :class="( total('saldo_final.saldo_c', items) >= 0 ? 'text-primary ' : 'text-danger '  ) + ( total('saldo_final.saldo_c') >= 0 ? 'text-primary ' : 'text-danger ' ) + ( filtro.tipo_saldo == 'A' ? 'small text-muted' : '' ) ">
                                        <span v-if="filtro.tipo_saldo == 'A'">
                                            <i class="fa-solid fa-copyright mr-1"></i>
                                        </span>
                                        {{ $util.formatMoeda(total('saldo_final.saldo_c', items)) }}
                                    </div>
                                </th>

                                <template v-if="tem_cheque_especial">
                                    <th class="text-right" :class="total('dc_cheque_especial', items) >= 0 ? 'text-primary' : 'text-danger'">{{ $util.formatMoeda(total('dc_cheque_especial')) }}</th>
                                    
                                    <th class="text-right">
                                        <div v-if="filtro.tipo_saldo != 'C'" :class="( ( total('saldo_final.saldo_r', items) + total('dc_cheque_especial', items) ) >= 0 ? 'text-primary ' : 'text-danger ' )">
                                            {{ $util.formatMoeda(total('saldo_final.saldo_r', items) + total('dc_cheque_especial', items)) }}
                                        </div>
                                        <div v-if="filtro.tipo_saldo != 'F'" :class="( ( total('saldo_final.saldo_c', items) + total('dc_cheque_especial', items) ) >= 0 ? 'text-primary ' : 'text-danger ' ) + ( filtro.tipo_saldo == 'A' ? 'small text-muted' : '' )">
                                            <span v-if="filtro.tipo_saldo == 'A'">
                                                <i class="fa-solid fa-copyright mr-1"></i>
                                            </span>
                                            {{ $util.formatMoeda(total('saldo_final.saldo_c', items) + total('dc_cheque_especial', items)) }}
                                        </div>
                                    </th>
                                </template>
                            </tr>

                            <!-- Contas do Grupo -->
                            <tr v-for="(conta, icx) in items" :key="'I' + igx + '.' + icx">
                                <td>
                                    {{ conta.search }}
                                    <span class="badge badge-light ml-2" v-if="conta.unidade_operacao && conta.unidade_operacao.st_sigla">{{ conta.unidade_operacao.st_sigla }}</span>
                                    <div class="small" v-if="false">
                                        <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in conta.js_classes" :key="icx" class="d-print-none">
                                            <span class="badge badge-success mr-1">
                                                {{ classe }}
                                            </span>
                                        </a>
                                    </div>
                                </td>
                                <td class="text-right">
                                    <div v-if="filtro.tipo_saldo != 'C'" :class=" conta.saldo_r >= 0 ? 'text-primary' : 'text-danger'">{{ $util.formatMoeda(conta.saldo_r) }}</div>
                                    <div v-if="filtro.tipo_saldo != 'F'" :class=" ( conta.saldo_c >= 0 ? 'text-primary ' : 'text-danger ' ) + ( filtro.tipo_saldo == 'A' ? 'small text-muted' : '' )">
                                        <span v-if="filtro.tipo_saldo == 'A'">
                                            <i class="fa-solid fa-copyright mr-1"></i>
                                        </span>
                                        {{ $util.formatMoeda(conta.saldo_c) }}
                                    </div>
                                </td>
                                <td class="text-right">
                                    <div v-if="filtro.tipo_saldo != 'C'">
                                        <a href="#" @click.prevent="abrir_lancamentos(conta, 'C')" class="text-dark card-link">
                                            {{ $util.formatMoeda(conta.entradas) }}
                                        </a>
                                    </div>
                                    <div v-if="filtro.tipo_saldo != 'F'" :class="filtro.tipo_saldo == 'A' ? 'small text-muted' : ''">
                                        <span v-if="filtro.tipo_saldo == 'A'">
                                            <i class="fa-solid fa-copyright mr-1"></i>
                                        </span>
                                        {{ $util.formatMoeda(conta.entradas_c) }}
                                    </div>
                                </td>
                                <td class="text-right">
                                    <div v-if="filtro.tipo_saldo != 'C'">
                                        <a href="#" @click.prevent="abrir_lancamentos(conta, 'D')" class="text-dark card-link">
                                            {{ $util.formatMoeda(conta.saidas) }}
                                        </a>
                                    </div>
                                    <div v-if="filtro.tipo_saldo != 'F'" :class="filtro.tipo_saldo == 'A' ? 'small text-muted' : ''">
                                        <span v-if="filtro.tipo_saldo == 'A'">
                                            <i class="fa-solid fa-copyright mr-1"></i>
                                        </span>
                                        {{ $util.formatMoeda(conta.saidas_c) }}
                                    </div>
                                </td>
                                <td class="text-right">
                                    <div v-if="filtro.tipo_saldo != 'C'" :class=" conta.saldo_final.saldo_r >= 0 ? 'text-primary' : 'text-danger'">{{ $util.formatMoeda(conta.saldo_final.saldo_r) }}</div>
                                    <div v-if="filtro.tipo_saldo != 'F'" :class=" ( conta.saldo_final.saldo_c >= 0 ? 'text-primary ' : 'text-danger ' ) + ( filtro.tipo_saldo == 'A' ? 'small text-muted' : '' )">
                                        <span v-if="filtro.tipo_saldo == 'A'">
                                            <i class="fa-solid fa-copyright mr-1"></i>
                                        </span>
                                        {{ $util.formatMoeda(conta.saldo_final.saldo_c) }}
                                    </div>
                                </td>

                                <template v-if="tem_cheque_especial">
                                    <td class="text-right" :class="conta.dc_cheque_especial >= 0 ? 'text-primary' : 'text-danger'">{{ $util.formatMoeda(conta.dc_cheque_especial) }}</td>
                                    <td class="text-right">
                                        <div v-if="filtro.tipo_saldo != 'C'" :class="( ( conta.saldo_final.saldo_r + conta.dc_cheque_especial ) >= 0 ? 'text-primary ' : 'text-danger ' )">
                                            {{ $util.formatMoeda(conta.saldo_final.saldo_r + conta.dc_cheque_especial) }}
                                        </div>
                                        <div v-if="filtro.tipo_saldo != 'F'" :class="( conta.saldo_final.saldo_c >= 0 ? 'text-primary ' : 'text-danger ' ) + ( filtro.tipo_saldo == 'A' ? 'small text-muted' : '' )">
                                            <span v-if="filtro.tipo_saldo == 'A'">
                                                <i class="fa-solid fa-copyright mr-1"></i>
                                            </span>
                                            {{ $util.formatMoeda(conta.saldo_final.saldo_c) }}
                                        </div>
                                    </td>
                                </template>
                            </tr>
                        </template>
                    </tbody>
                    <tfoot>
                        <tr class="table-info">
                            <th>Total</th>
                            <th class="text-right">
                                <div v-if="filtro.tipo_saldo != 'C'" :class="total('saldo_r') >= 0 ? 'text-primary' : 'text-danger' ">
                                    {{ $util.formatMoeda(total('saldo_r')) }}
                                </div>
                                <div v-if="filtro.tipo_saldo != 'F'" :class="( total('saldo_c') >= 0 ? 'text-primary ' : 'text-danger '  ) + ( total('saldo_c') >= 0 ? 'text-primary ' : 'text-danger ' ) + ( filtro.tipo_saldo == 'A' ? 'small text-muted' : '' ) ">
                                    <span v-if="filtro.tipo_saldo == 'A'">
                                        <i class="fa-solid fa-copyright mr-1"></i>
                                    </span>
                                    {{ $util.formatMoeda(total('saldo_c')) }}
                                </div>
                            </th>
                            <th class="text-right">
                                {{ $util.formatMoeda(total('entradas')) }}
                            </th>
                            <th class="text-right">
                                {{ $util.formatMoeda(total('saidas')) }}
                            </th>
                            <th class="text-right">
                                <div v-if="filtro.tipo_saldo != 'C'" :class="total('saldo_final.saldo_r') >= 0 ? 'text-primary' : 'text-danger' ">
                                    {{ $util.formatMoeda(total('saldo_final.saldo_r')) }}
                                </div>
                                <div v-if="filtro.tipo_saldo != 'F'" :class="( total('saldo_final.saldo_c') >= 0 ? 'text-primary ' : 'text-danger '  ) + ( total('saldo_final.saldo_c') >= 0 ? 'text-primary ' : 'text-danger ' ) + ( filtro.tipo_saldo == 'A' ? 'small text-muted' : '' ) ">
                                    <span v-if="filtro.tipo_saldo == 'A'">
                                        <i class="fa-solid fa-copyright mr-1"></i>
                                    </span>
                                    {{ $util.formatMoeda(total('saldo_final.saldo_c')) }}
                                </div>
                            </th>

                            <template v-if="tem_cheque_especial">
                                <th class="text-right" :class="total('dc_cheque_especial') >= 0 ? 'text-primary' : 'text-danger'">{{ $util.formatMoeda(total('dc_cheque_especial')) }}</th>
                                
                                <th class="text-right">
                                    <div v-if="filtro.tipo_saldo != 'C'" :class="( ( total('saldo_final.saldo_r') + total('dc_cheque_especial') ) >= 0 ? 'text-primary ' : 'text-danger ' )">
                                        {{ $util.formatMoeda(total('saldo_final.saldo_r') + total('dc_cheque_especial')) }}
                                    </div>
                                    <div v-if="filtro.tipo_saldo != 'F'" :class="( ( total('saldo_final.saldo_c') + total('dc_cheque_especial') ) >= 0 ? 'text-primary ' : 'text-danger ' ) + ( filtro.tipo_saldo == 'A' ? 'small text-muted' : '' )">
                                        <span v-if="filtro.tipo_saldo == 'A'">
                                            <i class="fa-solid fa-copyright mr-1"></i>
                                        </span>
                                        {{ $util.formatMoeda(total('saldo_final.saldo_c') + total('dc_cheque_especial')) }}
                                    </div>
                                </th>
                            </template>
                        </tr>
                    </tfoot>
                </table>

            </div>

            <br><br><br><br><br>

        </template>

        <lancamentos-modal ref="lancs" />

        <pre v-if="false">{{ dados }}</pre>
    </div>
</template>

<script>
import _ from 'lodash';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import LancamentosModal from './LancamentosModal.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';

export default {
    data() {
        return { 
            filtro: { 
                periodo: 'h', 
                id_unidade_operacao: this.$store.state.user.id_unidade_operacao, 
                search: "", 
                st_tipo: "", 
                tipo_saldo:  "F", 
                tipo_quebra: "G", 
                id_conta: "", 
                fluxo: "", 
            }, 
            dados: null, 
        }
    },

    components: { 
        AzInput,
        AzPeriodo, 
        AzEmptyState,
        LancamentosModal, 
        PrintExport, 
        CabecalhoGenerico, 
    }, 

    computed: { 
        lista() { 
            if ( !this.dados )
                return [];

            let reg = this.$util.getregex(this.filtro.search);

            return this.dados.contas.filter(item => !this.filtro.search || reg.test(JSON.stringify(item)));
        },

        lista_agrupada: function () { 
            return _.groupBy(this.lista, item => { 
                switch (this.filtro.tipo_quebra) {
                    case 'G': return '-';
                    case 'U': return item.unidade_operacao.search;
                    case 'T': return item.tipo;
                    default: return '-';
                }
            });
        },

        classes() { 
            return _.orderBy(
                    _.uniq(
                    this.dados.contas.flatMap(item => item.js_classes ? item.js_classes : [])
                ),
                item => item.toUpperCase()
            );
        },

        tem_cheque_especial() { 
            return this.lista.find(item => item.dc_cheque_especial > 0) ? true : false;
        }
    }, 

    methods: { 
        filtrar (texto) { 
            if ( this.filtro.search == '"' + texto + '"' ) { 
                this.filtro.search = "";
            } else { 
                this.filtro.search = '"' + texto + '"';
            }
        },

        total: function (campo, lista = null) { 
            if ( !lista ) { 
                lista = this.lista;
            }

            return lista.reduce((a, b) => a + parseFloat(_.get(b, campo)), 0);
        },

        load() { 
            this.$util.load(this, { 
                service: 'financeiro',
                func: 'contas', 
                parms: { 
                    ...this.filtro, 
                },
                loadTo: res => { 
                    this.dados = res; 
                },
            });
        },

        abrir_lancamentos (conta) { 
            let parms = { 
                filtros: { 
                    ...this.filtro, 
                    id_conta: conta.id_conta, 
                    // natureza: natureza, 
                }, 
                origem: 'B', 
            };

            this.$refs.lancs.abrir(parms);
        }, 
    },

    beforeMount() { 
        this.filtro.id_unidade_operacao = this.$store.state.user.id_unidade_operacao
            ? this.$store.state.user.id_unidade_operacao
            : this.$util.getCookie('id_unidade_operacao');
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Financeiro", path: "/financeiro/visao" },
            { name: "Contas", path: "/financeiro/visao" }
        ]);
        
        this.load();
    }
}
</script>
